import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air',
  templateUrl: './air.component.html',
  styleUrls: ['./air.component.scss']
})
export class AirComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
